import { desktopCopy, desktopFeatureName } from "../desktopFeatures";

import { Dialog } from "./Dialog";

import type { AppClassProperties } from "../types";
import type { DesktopFeature } from "../desktopFeatures";

export const DesktopFeatureButton = ({
  app,
  feature,
  children,
}: {
  app: AppClassProperties;
  feature: DesktopFeature;
  children?: React.ReactNode;
}) => (
  <button
    type="button"
    className="desktop-feature-button"
    data-desktop-feature={feature}
    onClick={() => app.requestDesktopFeature(feature)}
  >
    <span>{children || desktopFeatureName(feature, app.props.langCode)}</span>
    <span className="desktop-feature-badge">EXE</span>
  </button>
);

export const DesktopPurchaseDialog = ({
  app,
  feature,
  onClose,
}: {
  app: AppClassProperties;
  feature: DesktopFeature;
  onClose: () => void;
}) => {
  const copy = desktopCopy(app.props.langCode);
  return (
    <Dialog
      size="small"
      title={copy.title}
      onCloseRequest={onClose}
      className="desktop-purchase-dialog"
    >
      <div className="desktop-purchase-content">
        <span className="desktop-feature-badge">WINDOWS EXE</span>
        <h3>{desktopFeatureName(feature, app.props.langCode)}</h3>
        <p>{copy.body}</p>
        <p className="desktop-purchase-requirements">{copy.requirements}</p>
        <a
          className="desktop-purchase-link"
          href={app.props.desktopPurchaseUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="desktop-purchase-link"
        >
          {copy.buy}
        </a>
        <button
          type="button"
          className="desktop-purchase-continue"
          onClick={onClose}
        >
          {copy.keepDrawing}
        </button>
      </div>
    </Dialog>
  );
};
